/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CalcListItem } from './CalcListItem';
import {
    CalcListItemFromJSON,
    CalcListItemFromJSONTyped,
    CalcListItemToJSON,
    CalcListItemToJSONTyped,
} from './CalcListItem';

/**
 * CALCLIST.jsonの取得レスポンス
 * @export
 * @interface CalcListResponse
 */
export interface CalcListResponse {
    /**
     * 計算リスト
     * @type {Array<CalcListItem>}
     * @memberof CalcListResponse
     */
    calcList: Array<CalcListItem>;
}

/**
 * Check if a given object implements the CalcListResponse interface.
 */
export function instanceOfCalcListResponse(value: object): value is CalcListResponse {
    if (!('calcList' in value) || value['calcList'] === undefined) return false;
    return true;
}

export function CalcListResponseFromJSON(json: any): CalcListResponse {
    return CalcListResponseFromJSONTyped(json, false);
}

export function CalcListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalcListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'calcList': ((json['calcList'] as Array<any>).map(CalcListItemFromJSON)),
    };
}

export function CalcListResponseToJSON(json: any): CalcListResponse {
    return CalcListResponseToJSONTyped(json, false);
}

export function CalcListResponseToJSONTyped(value?: CalcListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'calcList': ((value['calcList'] as Array<any>).map(CalcListItemToJSON)),
    };
}

